import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {Subject, takeUntil} from "rxjs";
import {MobileCheck} from "../../services/mobile-check/mobile-check.service";
import {environment} from "../../../environments/environment";
import {SharedModule} from "../../shared/shared.module";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'colimo-disclaimer-page',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule
  ],
  templateUrl: './disclaimer-page.component.html',
  styleUrl: './disclaimer-page.component.scss'
})
export class DisclaimerPageComponent implements OnInit, OnDestroy {

  public isMobile: boolean;
  private stop$: Subject<boolean> = new Subject();

  constructor(private mobileCheck: MobileCheck) { }

  ngOnInit(): void {
    this.mobileCheck.getScreenSize().pipe(takeUntil(this.stop$)).subscribe((device) => {
      this.isMobile = device.isMobile;
    });
  }

  public ngOnDestroy(): void {
    this.stop$.next(true);
    this.stop$.unsubscribe();
  }

}
